import { IPMEventPayload } from 'integrations/interfaces';

export const formatPayload = (payload: IPMEventPayload): string => {
    if (!payload.type) {
        throw new Error('Message type is missing');
    }

    try {
        return JSON.stringify({ ...payload, windowName: window.name });
    } catch (error) {
        console.error('Error on formatting message', error);

        return null;
    }
};
